import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let Calendar = class Calendar extends Vue {
    render(h) {
        return h('a-date-picker', { props: {
                disabled: true,
                placeholder: "请输入"
            } });
    }
};
Calendar = tslib_1.__decorate([
    Component({ name: 'Calendar' })
], Calendar);
export default Calendar;
